import { Pipe, PipeTransform } from '@angular/core';
import { DeadlineMonthTypeEnum } from '@zaoblako/shared/common/enums/deadline.month.type.enum';
import { DeadlineTypeEnum } from '@zaoblako/shared/common/enums/deadline.type.enum';

const deadlineMonthTypeNames: Record<DeadlineMonthTypeEnum, string> = {
  [DeadlineMonthTypeEnum.CURRENT]: 'Текущий',
  [DeadlineMonthTypeEnum.NEXT]: 'Следующий'
};

@Pipe({
  standalone: true,
  name: 'deadlineMonthTypeName'
})
export class DeadlineMonthTypeNamePipe implements PipeTransform {
  public transform(deadlineMonthType: DeadlineTypeEnum): string {
    return deadlineMonthTypeNames[deadlineMonthType];
  }
}
